import React, {useState} from 'react';
import {Form, Input, Button, DatePicker, InputNumber} from 'antd';
import {REVENUES, STATISTICAL} from "../../assets/constants/route_path";
import {LeftCircleOutlined} from "@ant-design/icons";
import {useNavigate, useSearchParams} from "react-router-dom";
import {formatCurrency} from "../../utils/string-utils";
import {useLoading} from "../../context/LoadingContext";
import weekOfYear from "dayjs/plugin/weekOfYear";
import dayjs from "dayjs";
import {apiAddStatistical} from "../../api";
import {toastError, toastSuccess} from "../../utils/toast";

dayjs.extend(weekOfYear);

const {TextArea} = Input;

const initStatistical = {
    Date: dayjs().subtract(1, 'day'),
    balanceStartDate: 0,
    balanceEndDate: 0,
    revenue: 0,
    revenueNet: 0,
    refund: 0,
    deposit: 0,
    description: "",
    OTPConfirm: "",
};

const rules = {
    OTPConfirm: [
        { required: true, message: 'Vui lòng nhập mã code đăng nhập' },
        { min: 6, message: 'Mã code đăng nhập phải có 6 ký tự' },
    ],
};

export default function CreateStatistical() {
    const { setIsLoading } = useLoading()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const cpCode = searchParams.get('cpCode')
    const [form] = Form.useForm();

    const handleAddStatistical = async (values: any) => {
        try {
            setIsLoading(true);
            const req = {
                CpCode: cpCode,
                Day: values.Date.date(),
                Month: values.Date.month() + 1,
                Week: values.Date.week(),
                Year: values.Date.year(),
                balanceStartDate: values.balanceStartDate,
                balanceEndDate: values.balanceEndDate,
                revenue: values.revenue,
                revenueNet: values.revenueNet,
                refund: values.refund,
                deposit: values.deposit,
                description: values.description,
                OTPConfirm: values.OTPConfirm
            }
            const resp = await apiAddStatistical(req);
            if (resp.status === 200) {
                toastSuccess('Thêm dữ liệu thành công!')
                form.resetFields();
            }
        } catch (error) {
            toastError('Vui lòng kiểm tra lại thông tin!')
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 200, marginBottom: 20}}>
                <Button
                    onClick={() => navigate(REVENUES + STATISTICAL + `?cpCode=${cpCode}`)}
                    icon={<LeftCircleOutlined/>}
                    style={{background: 'gray', color: 'white'}}
                >
                    Trở lại
                </Button>
                <h2>Đối tác: {cpCode}</h2>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Form
                    style={{ width: '700px' }}
                    form={form}
                    onFinish={handleAddStatistical}
                    labelAlign="left"
                    labelCol={{span: 6}}
                    initialValues={initStatistical}
                >
                    <Form.Item
                        label="Thời gian"
                        name="Date"
                        rules={[{required: true, message: 'Vui lòng nhập thời gian'}]}
                    >
                        <DatePicker
                            style={{width: '100%'}}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Dư đầu ngày"
                        name="balanceStartDate"
                        rules={[{required: true, message: 'Vui lòng nhập dư đầu ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                        formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Dư cuối ngày"
                        name="balanceEndDate"
                        rules={[{required: true, message: 'Vui lòng nhập dư cuối ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                        formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Bán trong ngày"
                        name="revenue"
                        rules={[{required: true, message: 'Vui lòng nhập bán trong ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                        formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Bán trong ngày sau CK"
                        name="revenueNet"
                        rules={[{required: true, message: 'Vui lòng nhập bán trong ngày sau CK'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                        formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Nạp trong ngày"
                        name="deposit"
                        rules={[{required: true, message: 'Vui lòng nhập nạp trong ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Hoàn tiền trong ngày"
                        name="refund"
                        rules={[{required: true, message: 'Vui lòng nhập hoàn tiền trong ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                        formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Mô tả"
                        name="description"
                    >
                        <TextArea style={{width: '100%'}} rows={3}/>
                    </Form.Item>
                    <Form.Item label="Mã OTP xác nhận" name="OTPConfirm" rules={rules.OTPConfirm}>
                        <Input.Password name="OTPConfirm" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Thêm
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
}